import React, { useState, useRef, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ArrowUp, X } from 'lucide-react';

const FloatingLetterNav = ({ onLetterClick, currentLetter, availableLetters }) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const containerRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);

    // בדיקת מיקום הגלילה בעמוד
    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // בדיקת מצב הגלילה של סרגל האותיות
    const checkScroll = () => {
        if (containerRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
            setShowLeftArrow(scrollLeft > 0);
            setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', checkScroll);
            checkScroll();
            return () => container.removeEventListener('scroll', checkScroll);
        }
    }, []);

    const scroll = (direction) => {
        if (containerRef.current) {
            const scrollAmount = direction === 'left' ? -80 : 80;
            containerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={`fixed bottom-0 left-0 right-0 z-30 transition-all duration-300 
            ${isExpanded ? 'translate-y-0' : 'translate-y-full'}`}>
            {/* סרגל הניווט */}
            <div className="bg-[#f8f5f1] border-t border-[#e6dfd4] shadow-lg py-3">
                <h2 className="text-right text-[#937c5d] font-medium text-lg mb-2 px-8">לחץ על אות לבחירת המשפחה</h2>
                <div className="relative flex items-center max-w-full px-2 md:px-4">
                    {showLeftArrow && (
                        <button
                            onClick={() => scroll('left')}
                            className="absolute left-0 z-10 p-2 bg-gray-50 rounded-full text-gray-600 hover:bg-gray-100 touch-manipulation"
                        >
                            <ChevronLeft className="w-4 h-4"/>
                        </button>
                    )}

                    <div
                        ref={containerRef}
                        className="flex-1 overflow-x-auto flex items-center gap-1 px-8 no-scrollbar"
                        style={{WebkitOverflowScrolling: 'touch'}}
                    >
                        <div className="flex items-center gap-1 min-w-max">
                            {availableLetters.map((letter) => (
                                <button
                                    key={letter}
                                    onClick={() => {
                                        onLetterClick(letter);
                                        scrollToTop();
                                    }}
                                    className={`
                                        min-w-8 h-8 px-2 rounded-lg flex items-center justify-center text-sm
                                        font-medium transition-all duration-150 touch-manipulation
                                        ${currentLetter === letter
                                        ? 'bg-[#937c5d] text-white'
                                        : 'bg-white text-[#937c5d] hover:bg-[#e6dfd4]'
                                    }
                                    `}
                                >
                                    {letter}
                                </button>
                            ))}
                        </div>
                    </div>

                    {showRightArrow && (
                        <button
                            onClick={() => scroll('right')}
                            className="absolute right-0 z-10 p-2 bg-gray-50 rounded-full text-gray-600 hover:bg-gray-100 touch-manipulation"
                        >
                            <ChevronRight className="w-4 h-4"/>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FloatingLetterNav;